export enum MarketType {
    Singapore = 'Singapore',
    Japan = 'Japan',
    SouthKorea = 'South Korea',
}
